export default {
    videos: 'Vídeos',
    data_consumed: 'Dados consumidos (mb)',
    size: 'Tamanho (Mb)',
    lms_link: 'Ligação LMS',
    video: 'Vídeo',
    no_file: 'Não existe nenhum ficheiro',
    text_upload_file: 'Começar a carregar um novo ficheiro',
    upload: 'Upload',
    quota_label: 'Espaço usado',
    quota_of: '{used} de {limit}',
    quota_none: 'O seu plano não inclui espaço de armazenamento: não é possível carregar vídeos. Amplie o plano para os poder carregar.',
    quota_full: 'Encheu o espaço do seu plano. Esvazie a lixeira ou amplie o plano para carregar mais vídeos.',
    quota_exceeded: 'O vídeo ocupa {size} e só restam {free} livres no seu plano. Esvazie a lixeira ou amplie o plano.',
}